import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { createBrowserHistory } from "history";
import "./i18n";
import "./assets/fonts/fonts.css";
// Figma 4511-8374 uses Roboto Mono for code: Regular for inline code chips, Medium
// for code lines and the fill-in blank, Bold for the language bar. Self-hosted via
// @fontsource rather than a Google Fonts <link>, because the CSP in public/index.html
// deliberately restricts style-src to 'self' and font-src already allows 'self'.
import "@fontsource/roboto-mono/400.css";
import "@fontsource/roboto-mono/500.css";
import "@fontsource/roboto-mono/700.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// UX-11: strip noisy console output in production builds (kept in dev). console.error is
// preserved so the ErrorBoundary and real errors still surface. Minimal no-eject fix.
if (process.env.NODE_ENV === "production") {
  console.log = console.debug = console.info = console.warn = () => {};
}

const history = createBrowserHistory();

// WEB-03: fail loudly at startup if the realtime base URL is missing. Both the
// chat and lesson socket factories derive their URL from REACT_APP_WS_URL; when
// it is unset (CRA inlines it as undefined) every WebSocket silently refuses to
// connect. This guard ensures such a build can never ship unnoticed again.
if (!process.env.REACT_APP_WS_URL) {
  console.error(
    "[config] REACT_APP_WS_URL is not set — realtime chat and lesson " +
      "progress sockets will not connect. Set it in .env (e.g. " +
      "https://api.progpath.am); see .env.example.",
  );
}

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter history={history} forceRefresh={true}>
      <GoogleOAuthProvider clientId={clientId}>
        <App />
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>,
);
